import type { LoadableComponent } from '@loadable/component';
import loadable from '@loadable/component';

export const RESOURCE_FORM_MAP: Record<string, LoadableComponent<any>> = {
  Appointment: loadable(() => import('@views/Records/Appointments/Content')),
  Allergies: loadable(() => import('@views/Records/Allergies/Content')),
  Surgeries: loadable(() => import('@views/Records/Surgeries/Content')),
  'Emergency Visits': loadable(
    () => import('@views/Records/EmergencyVisits/Content')
  ),
  Hospitalizations: loadable(
    () => import('@views/Records/Hospitalizations/Content')
  ),
  'Imaging and Tests': loadable(
    () => import('@views/Records/ImagingTests/Content')
  ),
  'Genetic Information': loadable(
    () => import('@views/Records/GeneticInformation/Drilldown')
  ),
  'Medical Conditions': loadable(
    () => import('@views/Records/MedicalConditions/Content')
  ),
  'Vital Sign': loadable(
    () => import('@views/Records/VitalSigns/FormDrilldown')
  ),
  // Same component as 'Vital Sign' — it renders the Body tracker when handed a
  // TrackerType.Body, which is what /records/body/* already does. Without this
  // key useLoadForms drops the type, so it never reaches the "+ Add form" menu
  // and a discern resource titled "Body" hangs on "Loading form…".
  Body: loadable(() => import('@views/Records/VitalSigns/FormDrilldown')),
  Medications: loadable(() => import('@views/Records/Medications/Content')),
  Immunizations: loadable(() => import('@views/Records/Immunizations/Content')),
  'Lab Results': loadable(
    () => import('@views/Records/LabResults/SingleLabDrilldown')
  ),
  'Family History': loadable(
    () => import('@views/Records/FamilyHistory/Content')
  ),
  Insurance: loadable(() => import('@views/Records/Insurance/Content')),
};
